import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
import * as am5xy from '@amcharts/amcharts5/xy';

export default class ChartUtility {
  private static titleSize = 12;
  private static axisLabelSize = 10;

  static setChartTitle(root: am5.Root, chart: am5percent.PieChart | am5xy.XYChart, chartTitle: string) {
    chart.children.unshift(
      am5.Label.new(root, {
        text: chartTitle,
        fontSize: this.titleSize,
        fill: am5.color('#fff'),
        fontWeight: '500',
        textAlign: 'left',
        x: am5.percent(50),
        centerX: am5.percent(50),
        y: -30,
        centerY: 0,
        paddingTop: 30
      })
    );
  }

  static setXAxisLabel(xAxis: am5xy.ValueAxis<am5xy.AxisRenderer>, root: am5.Root, labelText: string) {
    xAxis.children.push(
      am5.Label.new(root, {
        text: labelText,
        fill: am5.color('#fff'),
        fontSize: this.axisLabelSize,
        fontWeight: 'bold',
        x: am5.percent(50),
        centerX: am5.percent(50)
      })
    );
  }

  static setYAxisLabel(yAxis: am5xy.ValueAxis<am5xy.AxisRenderer>, root: am5.Root, labelText: string) {
    yAxis.children.push(
      am5.Label.new(root, {
        text: labelText,
        fontSize: 10,
        fill: am5.color('#fff'),
        fontWeight: 'bold',
        rotation: -90,
        y: am5.percent(50),
        centerY: am5.percent(50),
        x: -10,
        centerX: am5.percent(50)
      })
    );
  }

  static createAxis(
    root: am5.Root,
    chart: am5xy.XYChart,
    axisType: 'x' | 'y'
  ): am5xy.ValueAxis<am5xy.AxisRenderer> {
    const renderer = axisType === 'x' ? am5xy.AxisRendererX.new(root, {}) : am5xy.AxisRendererY.new(root, {});

    const axis = chart[axisType === 'x' ? 'xAxes' : 'yAxes'].push(
      am5xy.ValueAxis.new(root, {
        renderer: renderer,
        strictMinMaxSelection: true,
        extraMax: 0.01,
        tooltip: am5.Tooltip.new(root, {})
      })
    );

    renderer.grid.template.setAll({
      stroke: am5.color('#4D4355'),
      visible: true,
      strokeOpacity: 1
    });

    axis.get('renderer').labels.template.setAll({ fill: am5.color('#fff') });
    axis.get('renderer').ticks.template.setAll({ stroke: am5.color('#fff') });

    return axis;
  }

  static createLegend(
    root: am5.Root,
    chart: am5percent.PieChart | am5xy.XYChart,
    nameField?: string
  ): am5.Legend {
    const legendContainer = chart.children.push(
      am5.Container.new(root, {
        layout: root.verticalLayout,
        width: am5.percent(20),
        height: am5.percent(100),
        x: am5.percent(105),
        centerX: am5.percent(100),
        y: am5.percent(50),
        centerY: am5.percent(50)
      })
    );

    const legend = legendContainer.children.push(
      am5.Legend.new(root, {
        layout: root.verticalLayout,
        nameField
      })
    );

    legend.labels.template.setAll({
      fontSize: this.axisLabelSize,
      fill: am5.color('#fff')
    });

    legend.valueLabels.template.setAll({
      fontSize: this.axisLabelSize,
      fill: am5.color('#fff')
    });

    return legend;
  }

  static turnOffZoomOutButton(chart: am5xy.XYChart): void {
    chart.zoomOutButton.set('forceHidden', true);
  }

  static hideAxisTooltip(axis: am5xy.ValueAxis<am5xy.AxisRenderer>, root: am5.Root): void {
    axis.set(
      'tooltip',
      am5.Tooltip.new(root, {
        forceHidden: true
      })
    );
  }
}
